<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        <div class="vx-row">
            <!-- CONTENT CARD - PROGRESS BAR/GOAL -->
            <div class="vx-col w-full sm:w-1/2 md:w-1/4 mb-base">
                <vx-card>
                    <img :src="require(`@/assets/images/pages/${card_ezopay.contentImg3}`)" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{ card_ezopay.title }}</h5>
                    </div>
                    <div class="mb-4">
                        <div class="flex justify-between">
                            <small class="font-semibold">{{ card_ezopay.current_progress }}</small>
                            <small class="text-grey">{{ card_ezopay.progress_goal }}</small>
                        </div>
						<vs-progress :percent="card_ezopay.progress_done_per" class="block mt-1 shadow-md"></vs-progress><br>
						<vs-select class="selectExample w-full mt-4" v-model="select1">
							<vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options1" />
						</vs-select><br>
                        <vs-input placeholder="Número" class="w-full mb-4" v-model="num_1" v-mask="'(##) #####-####'" />
						<vs-input placeholder="Pin" class="w-full mb-4" v-model="pin_1" />
                    </div>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="w-full mt-4 shadow-lg" type="gradient" color="#7367F0" @click="recargaone" gradient-color-secondary="#CE9FFC">{{ card_ezopay.btn_left_text }}</vs-button>
                    </div>
                </vx-card>
            </div>

            <!-- CONTENT CARD - PROGRESS BAR/GOAL -->
            <div class="vx-col w-full sm:w-1/2 md:w-1/4 mb-base">
                <vx-card>
                    <img :src="require(`@/assets/images/pages/${card_boleto.contentImg3}`)" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{ card_boleto.title }}</h5>
                    </div>
                    <div class="mb-4">
                        <div class="flex justify-between">
                            <small class="font-semibold">{{ card_boleto.current_progress }}</small>
                            <small class="text-grey">{{ card_boleto.progress_goal }}</small>
                        </div>
						<vs-progress :percent="card_boleto.progress_done_per" class="block mt-1 shadow-md"></vs-progress><br>
						<vs-select class="selectExample w-full mt-4" v-model="select2">
							<vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options2" />
						</vs-select><br>
                        <vs-input placeholder="Número" class="w-full mb-4" v-model="num_2" v-mask="'(##) #####-####'"/>
						<vs-input placeholder="Pin" class="w-full mb-4" v-model="pin_2" />
                    </div>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="w-full mt-4 shadow-lg" type="gradient" @click="recargatwo" color="#7367F0" gradient-color-secondary="#CE9FFC">{{ card_boleto.btn_left_text }}</vs-button>
                    </div>
                </vx-card>
            </div>
            <!-- CONTENT CARD - PROGRESS BAR/GOAL -->
            <div class="vx-col w-full sm:w-1/2 md:w-1/4 mb-base">
                <vx-card>
                    <img :src="require(`@/assets/images/pages/${card_transfer.contentImg3}`)" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{ card_transfer.title }}</h5>
                    </div>
                    <div class="mb-4">
                        <div class="flex justify-between">
                            <small class="font-semibold">{{ card_transfer.current_progress }}</small>
                            <small class="text-grey">{{ card_transfer.progress_goal }}</small>
                        </div>
						<vs-progress :percent="card_transfer.progress_done_per" class="block mt-1 shadow-md"></vs-progress><br>
						<vs-select class="selectExample w-full mt-4" v-model="select3">
							<vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options3" />
						</vs-select><br>
                        <vs-input placeholder="Número" class="w-full mb-4" v-model="num_3" v-mask="'(##) #####-####'"/>
						<vs-input placeholder="Pin" class="w-full mb-4" v-model="pin_3" />
                    </div>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="w-full mt-4 shadow-lg" type="gradient" color="#7367F0" @click="recargat" gradient-color-secondary="#CE9FFC">{{ card_transfer.btn_left_text }}</vs-button>
                    </div>
                </vx-card>
            </div>
            <!-- CONTENT CARD - PROGRESS BAR/GOAL -->
            <div class="vx-col w-full sm:w-1/2 md:w-1/4 mb-base">
                <vx-card>
                    <img :src="require(`@/assets/images/pages/${card_btc.contentImg3}`)" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{ card_btc.title }}</h5>
                    </div>
                    <div class="mb-4">
                        <div class="flex justify-between">
                            <small class="font-semibold">{{ card_btc.current_progress }}</small>
                            <small class="text-grey">{{ card_btc.progress_goal }}</small>
                        </div>
						<vs-progress :percent="card_btc.progress_done_per" class="block mt-1 shadow-md"></vs-progress><br>
						<vs-select class="selectExample w-full mt-4" v-model="select4">
							<vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in options4" />
						</vs-select><br>
                        <vs-input placeholder="Número" class="w-full mb-4" v-model="num_4" v-mask="'(##) #####-####'"/>
						<vs-input placeholder="Pin" class="w-full mb-4" v-model="pin_4" />
                    </div>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="w-full mt-4 shadow-lg" type="gradient" color="#7367F0" @click="recargaf" gradient-color-secondary="#CE9FFC">{{ card_btc.btn_left_text }}</vs-button>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {mask} from 'vue-the-mask'

export default{
	directives: {
		mask
	},
    data() {
        return {
			pin_1:'',
			pin_2:'',
			pin_3:'',
			pin_4:'',
			select1:10,
			options1:[
				{text:"R$ 10,00",value:10},
				{text:"R$ 13,00",value:13},
				{text:"R$ 15,00",value:15},
				{text:"R$ 20,00",value:20},
				{text:"R$ 30,00",value:30},
				{text:"R$ 50,00",value:50},
				{text:"R$ 100,00",value:100},
			],
			select2:15,
			options2:[
				{text:"R$ 15,00",value:15},
				{text:"R$ 20,00",value:20},
				{text:"R$ 30,00",value:30},
				{text:"R$ 40,00",value:40},
				{text:"R$ 50,00",value:50},
				{text:"R$ 100,00",value:100},
			],
			select3:12,
			options3:[
				{text:"R$ 12,00",value:12},
				{text:"R$ 15,00",value:15},
				{text:"R$ 20,00",value:20},
				{text:"R$ 25,00",value:25},
				{text:"R$ 35,00",value:35},
				{text:"R$ 100,00",value:100},
			],
			select4:10,
			options4:[
				{text:"R$ 10,00",value:10},
				{text:"R$ 15,00",value:15},
				{text:"R$ 20,00",value:20},
				{text:"R$ 25,00",value:25},
				{text:"R$ 30,00",value:35},
				{text:"R$ 35,00",value:35},
				{text:"R$ 40,00",value:40},
				{text:"R$ 75,00",value:75},
			],
            // card 3
            card_ezopay: {
                contentImg3: 'claro.jpg',
                title: 'CLARO',
                progress_done_per: 0,
                current_progress: 'R$ 0,00',
                progress_goal: 'R$ 200',
                btn_left_text: 'Efetuar Recarga',
                btn_right_text: 'Remove'

            },
            card_boleto: {
                contentImg3: 'tim.jpg',
                title: 'TIM',
                progress_done_per: 0,
                current_progress: 'R$ 0,00',
                progress_goal: 'R$ 200',
                btn_left_text: 'Efetuar Recarga',
                btn_right_text: 'Remove'

            },
            card_transfer: {
                contentImg3: 'vivo.png',
                title: 'VIVO',
                progress_done_per: 0,
                current_progress: 'R$ 0,00',
                progress_goal: 'R$ 200',
                btn_left_text: 'Efetuar Recarga',
                btn_right_text: 'Remove'

            },
            card_btc: {
                contentImg3: 'oi.jpg',
                title: 'OI',
                progress_done_per: 0,
                current_progress: 'R$ 0,00',
                progress_goal: 'R$ 200',
                btn_left_text: 'Efetuar Recarga',
                btn_right_text: 'Remove'

            },
			
            num_1: '',
			num_2: '',
			num_3: '',
			num_4: ''
        }
    },
    components: {
        VuePerfectScrollbar
    },
	methods: {
		recargaone()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Financeiro/Pagamento/Recarga', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")+"&numero="+this.num_1+"&operadora=claro"+"&pin="+this.pin_1+"&valor="+this.select1
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});
					}, 4000);

				}
				else
				{	
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}
				
			});
		},
		recargatwo()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Financeiro/Pagamento/Recarga', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")+"&numero="+this.num_2+"&operadora=tim"+"&pin="+this.pin_2+"&valor="+this.select2
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});
					}, 4000);

				}
				else
				{	
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}
				
			});
		},
		recargat()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Financeiro/Pagamento/Recarga', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")+"&numero="+this.num_3+"&operadora=vivo"+"&pin="+this.pin_3+"&valor="+this.select3
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});
					}, 4000);

				}
				else
				{	
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}
				
			});
		},
		recargaf()
		{
			this.$vs.loading({
				type:'radius',
			})

			fetch(this.$store.state.API_URL + 'Financeiro/Pagamento/Recarga', {
				method: 'POST',
				headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
				body: "token="+localStorage.getItem("token")+"&numero="+this.num_4+"&operadora=oi"+"&pin="+this.pin_4+"&valor="+this.select4
			})
			.then((response) => response.text())
			.then((responseData) => {
				var dados = JSON.parse(responseData);
				if(dados.done == true)
				{
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});
					}, 4000);

				}
				else
				{	
					setTimeout( ()=> {
						this.$vs.loading.close();
						this.$vs.notify({
							title: 'SPSaude',
							text: dados.message,
							iconPack: 'feather',
							icon: 'icon-alert-circle',
							color: 'warning'
						});

					}, 4000);
				}
				
			});
		},
	},
    mounted() {
        
    }   
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }
    
    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}
</style>